import { render, staticRenderFns } from "./TeamDetail.vue?vue&type=template&id=dacb5352&scoped=true"
import script from "./TeamDetail.vue?vue&type=script&lang=js"
export * from "./TeamDetail.vue?vue&type=script&lang=js"
import style0 from "./TeamDetail.vue?vue&type=style&index=0&id=dacb5352&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dacb5352",
  null
  
)

export default component.exports